import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as ObjectActions from '../user/actions';
import { componentPermissionActions } from './component-permission.actions';
import { ComponentPermissionService } from '../../shared/service/component-permission/component-permission.service';

@Injectable()
export class ComponentPermissionEffects {
  constructor(
    private actions$: Actions,
    private readonly componentPermissionService: ComponentPermissionService,
  ) {}

  loadCurrentUserAssignments$ = createEffect(() =>
    this.actions$.pipe(
      ofType(componentPermissionActions.loadCurrentUserAssignments.type),
      switchMap(() => {
        return this.componentPermissionService.getCurrentUserAssignments().pipe(
          map(({ data }) => componentPermissionActions.setCurrentUserAssignmentsToStore({ assignments: data })),
          catchError((errorRes) => {
            return of(new ObjectActions.FetchError(errorRes));
          }),
        );
      }),
    ),
  );
}
